export const oilAndGasMapTutorialSteps = [
  {
    popover: {
      title:
        '<div style="font-size: 1.4rem; text-align: center;"><strong>Map Performance Boost</strong></div>',
      description:
        '<div style="font-size: 1.3rem; text-align: center; margin-bottom: 16px;">🎉 Congratulations! 🎉</div>You have been upgraded to the BETA version of our new, faster map — our map has been rebuilt for speed and a more seamless way to navigate the globe. If you notice any issues, please let us know at <a href="mailto:info@welligence.com">info@welligence.com</a>.',
    },
  },
];
